import { render, staticRenderFns } from "./ButtonStripe.vue?vue&type=template&id=2c2fc768&scoped=true"
import script from "./ButtonStripe.vue?vue&type=script&lang=js"
export * from "./ButtonStripe.vue?vue&type=script&lang=js"
import style0 from "./ButtonStripe.vue?vue&type=style&index=0&id=2c2fc768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2fc768",
  null
  
)

export default component.exports